import { State, Action, StateContext, Selector } from '@ngxs/store';
import { AppService } from './service';
import { IAppState, ICountry } from './types';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { FetchCountries } from './actions';

const defaults: IAppState = {
    countries: null
};

@State<IAppState>({
    name: 'app',
    defaults
})
@Injectable()
export class AppState {

    @Selector()
    static countries(state: IAppState) {
        return state.countries;
    }

    constructor(
        private appService: AppService
    ) { }

    @Action(FetchCountries)
    FetchCountries(ctx: StateContext<IAppState>) {
        const state = ctx.getState();
        if (!state.countries) {
            return this.appService.fetchCountries()
                .pipe(
                    tap((countries: ICountry[]) => ctx.patchState({ countries }))
                );
        }
    }

}
